module.exports = __webpack_public_path__ + "static/media/winB.29f9c83d.png";